/**
 * Jerarquía por rango (spec 2026-10-07 §4). Módulo puro.
 *
 * `rango` es un campo numérico de roles/{id} (lo fija scripts/set_role_rank.js):
 * root 100, supervisora 80, contador 60, admin 40, auxiliar 40, cliente y
 * usuario 10. Un rol sin `rango` vale 0. Root vale 100 por su marca
 * documents.root, tenga o no el campo (igual que las reglas).
 *
 *  - Ajustar la matriz de empresa de T: rango(E) > rango(T). Un rol objetivo
 *    DESCONOCIDO (null/undefined: no se pudo leer) no se ajusta.
 *  - Encender o apagar permisos de eliminar: rango(E) ≥ 60.
 *  - Restringir carpetas: rango(E) ≥ 60.
 * Los flags de eliminar se comparan normalizados con toGranular, como las
 * reglas (delFlags en firestore.rules): una matriz vieja guardada en granular
 * sin cambios no cuenta como cambio.
 *
 * COPIA CJS en daysi-cloud-functions/scripts/rank_lib.js; rank.test.js exige
 * que den lo mismo.
 */
import { toGranular } from './permission_granular';

export const RANK_ROOT = 100;
export const RANK_MIN_DELETE = 60;
export const RANK_MIN_RESTRICT = 60;

export const DELETE_FLAGS = [
  'documents.delete', 'documents.deleteXml', 'documents.deleteLinked',
  'documents.deleteAccounting', 'documents.deleteReference', 'folders.delete',
];

export const rankOf = (role) => {
  if (!role || typeof role !== 'object') return 0;
  if (role.documents && role.documents.root === true) return RANK_ROOT;
  const r = role.rango;
  return typeof r === 'number' && Number.isFinite(r) ? r : 0;
};

export const canAdjust = (editorRole, targetRole) => {
  if (!editorRole || !targetRole) return false;
  return rankOf(editorRole) > rankOf(targetRole);
};

export const canToggleDelete = (editorRole) => rankOf(editorRole) >= RANK_MIN_DELETE;

export const canRestrict = (editorRole) => rankOf(editorRole) >= RANK_MIN_RESTRICT;

export const deleteFlagsOf = (perms) => {
  const d = toGranular({ documents: (perms && perms.documents) || {} }).documents;
  const f = (perms && perms.folders) || {};
  return {
    'documents.delete': !!d.delete,
    'documents.deleteXml': !!d.deleteXml,
    'documents.deleteLinked': !!d.deleteLinked,
    'documents.deleteAccounting': !!d.deleteAccounting,
    'documents.deleteReference': !!d.deleteReference,
    'folders.delete': !!f.delete,
  };
};

export const diffTouchesDelete = (before, after) => {
  const a = deleteFlagsOf(before);
  const b = deleteFlagsOf(after);
  return DELETE_FLAGS.some((k) => a[k] !== b[k]);
};

export default rankOf;
